const storageBucket = process.env.REACT_APP_S3_URI

export default storageBucket;